angular.module('cvsApp').service('msgManagerService', ['cvsAppData',function(CAD){

	var msgManagerService = function(){
	
		this.errorMsg = function(error){
			CVS.errorMsg = {
				SERVER_ERROR:"We're sorry. There was a processing error. Please try again. If the issue continues, please call us toll-free 1-800-237-2767 for help. For help related to Billing call toll-free at 1-800-250-9631.",
				GEN_ERROR :"There is some problem. Please access after some time.",
				FNAME_REQUIRED:"Enter a first name.",
				FNAME_INVALID:"First name is invalid.",
				FNAME_MAX_CHAR:"Maximum length is 30 characters.",
				FNAME_NO_ASCII_CHAR:"Non ascii characters are not allowed.",
				LNAME_REQUIRED:"Enter a first name.",
				LNAME_INVALID:"First name is invalid.",
				LNAME_MAX_CHAR:"Maximum length is 30 characters.",
				LNAME_NO_ASCII_CHAR:"Non ascii characters are not allowed.",
				lockout: "For security purposes, access to this page has been deactivated. Register for an account to pay online, or call Billing toll-free at 1-800-250-9631 to pay by phone.",
				twoHbsId: "We have more than one record for you. Please call Billing toll-free at 1-800-250-9631 to pay your balance and resolve the issue.",
				authLockout: "We’re sorry, but you have tried to verify your identity too many times. For security purposes, access to pay your	balance has been locked. Register for an account to pay online, or call Billing toll-free at 1-800-250-9631 to pay by phone.",
				invalidData: "ZIP code or date of birth is incorrect",
				QR_SERVER_ERROR:"We're sorry. There was a processing error. Please try again. If the issue continues, please call us toll-free 1-800-237-2767 for help. For help related to Billing call toll-free at 1-800-250-9631."
				
			}
			
			return CVS.errorMsg[error];
		}
		this.errorCodes=function(code){
			return {
					INVALID_DOB:{code:"7724",msg:""},
					EXCEEDED_ATTEMPTS:{code:"7723",msg:""},
					LINK_INVALID:{code:"6024",msg:""},
					LINK_EXPIRED:{code:"6025",msg:""},
					LINK_LOCKED:{code:"6027",msg:""},
					USER_EXISTS:{code:"5004",msg:""},
					USER_EXISTS_2:{code:"5005",msg:""},
					SEC_MATCH_PASSWORD:{code:"7718",msg:""},
					SUCCESS:{code:"0000",msg:""},
					TRACK_NOT_FOUND:{code:"6631",msg:""}
				}
		}
		this.Message = function(msg){
			CVS.Message = {
				noHistory: 'You have no payment transactions for the selected time period.',
				errorHistory: 'We\'re sorry. There was a processing error. Please try again. If the issue continues, call Billing toll-free at 1-800-250-9631.'

			}
			return CVS.Message[msg];
		}

}
 return new msgManagerService();

}]);
